import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { WhiteDoubleArrow } from "./WhiteDoubleArrow";
import MenuItem from "@mui/material/MenuItem";

export const SortBy = ({ sorting, setSorting }) => {
  const handleSortChange = (event) => setSorting(event.target.value);
  return (
    <div className="flex-row align-items-center gap">
      <div className="view-sort">Sort by:</div>
      <Box>
        <FormControl size="small" fullWidth>
          <Select
            labelId="sort-groups-select"
            id="sort-groups-select"
            className="select-menu"
            sx={{
              color: "white",
              minWidth: 120,
            }}
            IconComponent={WhiteDoubleArrow}
            value={sorting}
            onChange={handleSortChange}
          >
            <MenuItem value="rate">Rate</MenuItem>
            <MenuItem value="monthlyPayment">Monthly Payment</MenuItem>
            <MenuItem value="closingCosts">Lender Cost</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </div>
  );
};
